import React, { useEffect, useState } from 'react';
import { Box, Text, Button, UnorderedList, ListItem } from '@chakra-ui/react';
import { FaDownload } from 'react-icons/fa';
import Lottie from 'lottie-react';

const HomeScreen = () => {
  const [animationData, setAnimationData] = useState(null);
  const [loading, setLoading] = useState(true); // To handle loading state
  const [error, setError] = useState(null);     // To handle errors

  useEffect(() => {
    // Fetch the Lottie animation JSON from the URL
    fetch('https://lottie.host/d1117acb-6873-473d-a8d9-41007a184d51/HVYicowATo.json')
      .then((response) => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then((data) => {
        setAnimationData(data);
        setLoading(false);
      })
      .catch((error) => {
        console.error('Error loading Lottie animation:', error);
        setError(error);
        setLoading(false);
      });
  }, []);

  const handleDownload = () => {
    alert('Download button clicked!');
  };

  return (
    <Box
      minH="100vh"
      width="100%"
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      p={4}
      bgGradient="linear(to-b, #6190bc, #94d1ed)"
      position="relative"
    >
      {/* Title Text */}
      <Text fontFamily="FjallaOne, sans-serif" fontSize="34px" color="#FDC669" textShadow="2px 2px 1px #ED1A23">
        The Lost Diamond Journey
      </Text>

      {/* Short Promo Text */}
      <Text fontFamily="FjallaOne, sans-serif" fontSize="18px" color="#FDC669" textShadow="2px 2px 1px #ED1A23" mt={4} textAlign="center">
        Embark on the ultimate adventure across Africa! Join The Lost Diamond Journey, visit 30 iconic locations, and prove yourself as a true explorer by capturing and sharing your travels with the world.
      </Text>

      {/* Lottie Animation */}
      <Box display="flex" justifyContent="center" alignItems="center" marginTop="20px">
        {loading && <Text>Loading animation...</Text>}
        {error && <Text>Error loading animation.</Text>}
        {animationData && (
          <Lottie
            animationData={animationData}
            loop={true}
            style={{ width: 200, height: 200 }}
          />
        )}
      </Box>

      {/* Short App Description */}
      <Text fontFamily="FjallaOne, sans-serif" fontSize="18px" color="#FDC669" textShadow="2px 2px 1px #ED1A23" mt={4} textAlign="center">
        The Lost Diamond Journey is an interactive travel app that challenges adventurers to visit 30 unique locations across Africa. Track your travels, upload photos, share your journey, and compete with other teams for the title of True Explorer.
      </Text>

      {/* Download Button */}
      <Button
        leftIcon={<FaDownload />}
        bgGradient="linear(to-r, orange.400, pink.500)"
        size="lg"
        color="white"
        mt={6}
        onClick={handleDownload}
        rightIcon={<span role="img" aria-label="phone">📱</span>}
      >
        Download for iOS
      </Button>

      {/* Long "How it Works" Section */}
      <Box mt={10} p={4} textAlign="left" maxW="800px" bg="#6190bc" borderRadius="10px" boxShadow="0px 4px 12px rgba(0, 0, 0, 0.1)">
        <Text fontFamily="FjallaOne, sans-serif" fontSize="26px" color="#FDC669" textShadow="2px 2px 1px #ED1A23" mb={4} textAlign="center">
          How it Works
        </Text>
        <Text fontFamily="FjallaOne, sans-serif" fontSize="18px" color="#FDC669" textShadow="1px 1px 1px #ED1A23" mb={4}>
          The Lost Diamond Journey is a unique travel challenge designed for teams of explorers. Here’s how it works:
        </Text>

        <UnorderedList spacing={3} color="#FDC669" fontFamily="FjallaOne, sans-serif" fontSize="18px" textShadow="1px 1px 1px #ED1A23">
          <ListItem>
            <strong>Create Your Team:</strong> Start by creating a username and a team name. You’ll be representing your team throughout the journey.
          </ListItem>
          <ListItem>
            <strong>Explore Africa:</strong> Your mission is to visit 30 designated locations across the continent, marked as red dots on the app’s map. These locations include Addis Abeba, Bahr el Ghazal, Dakar, Darfur, Drakbergen, etc.
          </ListItem>
          <ListItem>
            <strong>Document Your Travels:</strong> At each location, upload photos and text descriptions to capture the essence of your adventure. You can also add the date of your visit. These uploads will serve as proof of your exploration.
          </ListItem>
          <ListItem>
            <strong>Share Your Journey:</strong> When uploading content, you can choose to make it public or private. Public photos and descriptions will appear on the global map, allowing all users to see your progress. Private uploads will only be visible to your team.
          </ListItem>
          <ListItem>
            <strong>Compete and Collaborate:</strong> Follow other teams’ progress by viewing their public uploads. You can draw inspiration from their travels or aim to be the first team to complete all 30 locations.
          </ListItem>
          <ListItem>
            <strong>Celebrate Your Achievement:</strong> Once you’ve visited all locations and documented your journey, you’ll earn the title of True Explorer. Share your achievement with the world and continue to inspire others to explore Africa!
          </ListItem>
        </UnorderedList>
      </Box>
    </Box>
  );
};

export default HomeScreen;
